<svg
  [attr.width]="size()"
  [attr.height]="size()"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
>
  <path [attr.d]="d()" />
</svg>
